<template>
  <form class="email-billing">
    <h3 class="title">Email для отправки документов</h3>
    <fieldset class="group">
      <div class="checkbox-wrapper">
        <AppCheckbox
          :modelValue="regEmailBillingEnabled"
          @update:modelValue="toggleRegistrationEmail($event)"
        />
      </div>
      <input
        type="text"
        class="form-control form-control-light billing-email-input"
        :value="registrationEmail"
        disabled
      />
    </fieldset>
    <fieldset class="group">
      <div class="checkbox-wrapper">
        <AppCheckbox
          :modelValue="accountingEmailEnabledLocal"
          @update:modelValue="toggleAccountingEmail($event)"
        />
      </div>
      <input
        type="text"
        class="form-control form-control-light billing-email-input"
        :class="{ 'is-invalid': $v.accountingEmailLocal.$error }"
        placeholder="Введите дополнительный Email"
        v-model.trim="accountingEmailLocal"
        @blur="$v.accountingEmailLocal.$touch()"
        @input="changeAccountingEmail"
        @focus="inputFocused = true"
      />
    </fieldset>
    <span
      v-if="
        needUpdate ||
        (inputFocused && accountingEmail !== accountingEmailLocal) ||
        (inputFocused && !accountingEmailLocal)
      "
      class="warning"
    >
      Поставьте чекбокс для сохранения и отправки e-mail
    </span>
    <span
      v-if="$v.accountingEmailLocal.$error && accountingEmailLocal"
      class="error"
    >
      Некорректный Email
    </span>
  </form>
</template>

<script>
import AppCheckbox from "@/components/common/AppCheckbox.vue";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { email, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "EmailBilling",
  components: { AppCheckbox },
  data() {
    return {
      accountingEmailLocal: "",
      accountingEmailEnabledLocal: false,
      needUpdate: false,
      enterEmailMessageVisible: false,
      inputFocused: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    accountingEmailLocal: {
      required: requiredIf(function () {
        return !this.accountingEmailEnabled;
      }),
      email,
    },
  },
  methods: {
    ...mapActions("emailBilling", ["getEmails", "patchEmails"]),
    toggleRegistrationEmail(value) {
      console.log(value);
      if (!this.accountingEmailEnabled) return;
      this.patchEmails({
        registrationEmail: this.registrationEmail,
        regEmailBillingEnabled: value,
        accountingEmail: this.accountingEmail,
        accountingEmailEnabled: this.accountingEmailEnabled,
      });
    },
    async toggleAccountingEmail(value) {
      if (!this.regEmailBillingEnabled && this.accountingEmailEnabledLocal)
        return;

      this.$v.accountingEmailLocal.$touch();
      if (this.$v.accountingEmailLocal.$invalid) return;

      await this.patchEmails({
        registrationEmail: this.registrationEmail,
        regEmailBillingEnabled: this.regEmailBillingEnabled,
        accountingEmail: this.accountingEmailLocal,
        accountingEmailEnabled: this.needUpdate ? true : value,
      });

      this.accountingEmailEnabledLocal = value;
      this.needUpdate = false;
    },
    changeAccountingEmail(event) {
      const newValue = event.target.value;
      if (newValue !== this.accountingEmail && this.accountingEmailEnabled) {
        this.accountingEmailEnabledLocal = false;
        this.needUpdate = true;
      }
      if (newValue === this.accountingEmail && this.accountingEmailEnabled) {
        this.accountingEmailEnabledLocal = true;
        this.needUpdate = false;
      }
    },
  },
  computed: {
    ...mapGetters("emailBilling", [
      "registrationEmail",
      "regEmailBillingEnabled",
      "accountingEmail",
      "accountingEmailEnabled",
    ]),
  },
  watch: {
    accountingEmail(value) {
      this.accountingEmailLocal = value ? value : "";
    },
    accountingEmailEnabled(value) {
      this.accountingEmailEnabledLocal = value;
    },
  },
  mounted() {
    this.getEmails();
    this.accountingEmailLocal = this.accountingEmail
      ? this.accountingEmail
      : "";
    this.accountingEmailEnabledLocal = this.accountingEmailEnabled;
  },
};
</script>

<style scoped lang="less">
@import "../../assets/less/commonStyles.less";

.email-billing {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 438px;
  height: 100%;
  .title {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    margin-left: 32px;
    max-height: 16px;
  }
  .group {
    padding: 0;
    margin: 0;
    border: none;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    .checkbox-wrapper {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .billing-email-input {
      max-height: 36px;
    }
    .is-invalid {
      color: #f84242;
    }
  }
  .error,
  .warning {
    margin-left: 32px;
    font-weight: 400;
    font-size: 14px;
  }
  .error {
    color: #f84242;
  }
}
</style>
